import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { Feedback } from 'types'

interface Data {
  feedback: Feedback
}

export interface Variables {
  rating?: string
  feedback?: any
}

export const updateFeedback = async (id: number, { rating, feedback }: Variables) => {
  const res = await sendToApi<Data>(`/feedbacks/${id}`, {
    method: 'PATCH',
    body: {
      rating,
      feedback,
    },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export interface Options extends Omit<UseMutationOptions<Feedback, Error, Variables>, 'mutationFn'> {}

export const useUpdateFeedback = (id: number, options?: Options) => {
  return useMutation<Feedback, Error, Variables>(
    async (vars) => {
      const result = await updateFeedback(id, vars)

      return result.feedback
    },
    {
      ...options,
    },
  )
}
